import React from "react";
import { Avatar, AvatarGroup } from "@mui/material";

const projectColors = {
  SG: "#6A0DAD",
  PQ: "#1976d2",
  CB: "#d81b60"
};

const ProjectAvatar = ({ projects }) => (
  <AvatarGroup 
    max={3} 
    sx={{ justifyContent: 'center' }}
    componentsProps={{
      additionalAvatar: {
        sx: {
          width: 40,
          height: 40,
          fontSize: '13px',
          bgcolor: '#000',
          position: 'relative',
          zIndex: '99',
        }
      }
    }}
  >
    {projects.map((p) => (
      <Avatar
        key={p}
        sx={{ 
          width: 40, 
          height: 40, 
          fontSize: '13px', 
          bgcolor: projectColors[p] 
        }}
      >
        {p}
      </Avatar>
    ))}
  </AvatarGroup>
);

export default ProjectAvatar;